import { Component, Input, OnInit } from '@angular/core';

import { Lesson, Pupil } from '@df/interfaces';
import { AbsentService } from '@app/core/services/absent.service';

@Component({
    selector: 'app-absent',
    templateUrl: './absent.component.html',
    styleUrls: ['./absent.component.scss']
})
export class AbsentComponent implements OnInit {
    @Input() lesson: Lesson;
    @Input() student: Pupil;

    isAbsent: boolean = false;

    constructor(private absentService: AbsentService) {}

    ngOnInit(): void {
        if (this.lesson.attending_students.indexOf(this.student.id) === -1) {
            this.isAbsent = true;
        }
    }

    checkBoxAbsentClicked(): void {
        this.isAbsent = !this.isAbsent;
        const data = { add: !this.isAbsent, student: this.student.id };
        this.absentService.setLessonAttending(this.lesson.id, data).subscribe();
        if (this.isAbsent) {
            this.absentService.addToAbsent(this.student.id);
        } else {
            this.absentService.removeFromAbsent(this.student.id);
        }
    }
}
